import React from 'react'
import { useSelector } from 'react-redux';

const Footer = ({ afooter }) => {
    const { config } = useSelector(state => state.configSlice);
    const { contact } = useSelector(state => state.configSlice);
    
    return (
        <>
            <div className={`footer ${afooter}`}>
                <div className="container">
                    <div className='row align-items-center'>
                        <div className="col-md-6">
                            <div className="footerImage">
                               <img src={config.logo} className='img-fluid logofooter' alt="" />
                            </div>
                        </div>
                        <div className="col-md-6 text-md-end">
                            <a className='text-white' href={`tel:${contact.email}`}>{contact.email}</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Footer
